import React from 'react';

/** The assistant's mark in the document chat: a grey "AI" monogram (28px, 8px radius), never a lime avatar. */
export function AiMonogram() {
  return (
    <span
      aria-hidden
      className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-muted text-[10.5px] font-bold text-foreground/80"
    >
      AI
    </span>
  );
}

export default AiMonogram;
